import type { HqHalfyearRepository } from './repository';
import { HqControlWorkspace } from './control-workspace';

export interface HqHalfyearReviewWorkspaceProps {
  repository: HqHalfyearRepository | null;
  sessionKey: string;
  actorId: string;
  onOpen: (featureId: string, siteId: string) => void;
  onBack?: () => void;
  onSaved?: () => void;
  onOpenHistorical?: (id: string) => void;
  initialYear?: number;
  initialHalf?: 1 | 2;
  initialTopicId?: string;
}

/** HQ control reads source work; the legacy saved review/history contracts remain intact. */
export function HqHalfyearReviewWorkspace(props: HqHalfyearReviewWorkspaceProps) {
  return <HqControlWorkspace key={`${props.sessionKey}:${props.actorId}:${props.initialTopicId ?? 'goals-policy'}`}
    actorId={props.actorId} initialYear={props.initialYear} initialHalf={props.initialHalf}
    initialTopicId={props.initialTopicId} onOpen={props.onOpen} onBack={props.onBack}
    onOpenHistorical={props.onOpenHistorical} />;
}
